// extracted by mini-css-extract-plugin
export default {"card":"V4-z"};